import FJActionConstant from "../../constant/FJActionConstant";
import FJCanvasStore from "../../store/FJCanvasStore";
import FJUtil from "../../util/FJUtil";
import FJCoreConstant from "../../core/constant/FJCoreConstant";
import {FJFontManager} from "fj-graph";
import {FJFontAction, FJMediaAction, FJModalAction, FJPreviewAction} from "./FJRoot.action";
import FJLocalStore from "../../store/FJLocalStore";
import FJViewConstant from "../../constant/FJViewConstant";
import FJMediaCacheStore from "../../store/FJMediaCacheStore";

let FJWatermarkAction = (function () {
	return {

    /**
     * @description 设置水印类型
     * @param type
     * @return {function(*): void}
     */
	  changeWatermarkTypeAction: function (type) {
	    return (dispatch) => {
	      FJCanvasStore.executeSync(FJCanvasStore.command.SET_WATERMARK_DATA, {activeType: type});
        dispatch(FJPreviewAction.setVideoPauseAction());
        dispatch(this.setWatermarkTypeAction(type));
	      dispatch(this.updateWatermarkAction());
      };
    },

    /**
     * @description 设置水印类型
     * @param watermarkType
     * @return {{watermarkType, type: string}}
     */
	  setWatermarkTypeAction: function (watermarkType) {
	    return {
	      type: FJActionConstant.SET_WATERMARK_TYPE,
        watermarkType,
      }
    },

		/**
		 * @description 设置水印文字
		 * @param value
		 * @returns {{type: string, watermarkText: *}}
		 */
		setWatermarkTextValueAction: function (value) {
			return {
				type: FJActionConstant.SET_WATERMARK_TEXT_VALUE,
				watermarkText: value
			};
		},

    /**
     * @description 设置水印文字字体
     * @param watermarkFontFamily
     * @returns {{type: string, watermarkText: *}}
     */
    setWatermarkFontFamilyAction: function (watermarkFontFamily) {
      return {
        type: FJActionConstant.SET_WATERMARK_FONT_FAMILY,
        watermarkFontFamily,
      };
    },

    /**
     * @description 水印文字颜色更改
     * @param type
     * @param color
     * @return {function(*): void}
     */
    watermarkFontColorChangeAction: function (type, color) {
      return (dispatch) => {
        FJUtil.toggleScope(type);
        let {mainColor} = color;
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_WATERMARK_DATA, {fontColor: mainColor}, {type});
        dispatch(this.setWatermarkFontColorAction(mainColor))
      };
    },

    /**
     * @description 设置水印文字颜色
     * @param color
     * @returns {{type: string, watermarkText: *}}
     */
    setWatermarkFontColorAction: function (color) {
      return {
        type: FJActionConstant.SET_WATERMARK_TEXT_COLOR,
        color,
      };
    },

		/**
		 * @description 修改水印文字大小
		 * @param size
		 * @returns {{watermarkTextSize: *, type: string}}
		 */
		setWatermarkSizeAction: function(size) {
			return {
				type: FJActionConstant.SET_WATERMARK_SIZE,
				watermarkSize: size
			}
		},

		/**
		 * @description 修改文字透明度
		 * @param opacity
		 * @returns {{watermarkTextOpacity: *, type: string}}
		 */
		setWatermarkOpacityAction: function(opacity) {
			return {
				type: FJActionConstant.SET_WATERMARK_OPACITY,
				watermarkOpacity: opacity
			}
		},

    /**
     * @description 设置水印位置
     * @param position
     * @return {{watermarkPosition, type: string}}
     */
		setWatermarkPositionAction: function(position) {
			return {
				type: FJActionConstant.SET_WATERMARK_POSITION,
				watermarkPosition: position
			}
		},

		/**
		 * @description 修改水印文字
		 * @param type
		 * @param value
		 * @returns {function(...[*]=)}
		 */
		watermarkTextChangeAction: function (type, value) {
			return (dispatch) => {
			  let _value = value.slice(0, 1000);
				FJCanvasStore.executeSync(FJCanvasStore.command.SET_WATERMARK_DATA, {text: _value}, {type});
        dispatch(this.setWatermarkTextValueAction(_value));
      }
		},

    /**
     * @description 修改水印字体
     * @param fontFamily
     */
    watermarkFontFamilyChangeAction: function (fontFamily) {
      return (dispatch, getState) => {
        const state = getState();
        const currentFontFamily = state.watermark.watermarkFontFamily;
        if (fontFamily === currentFontFamily) {
          return
        }
        FJFontManager.loadFont(fontFamily, () => {
          dispatch(FJFontAction.updateLoadingFontAction(FJFontManager.loadingFonts()));
          FJCanvasStore.executeSync(FJCanvasStore.command.SET_WATERMARK_DATA, {fontFamily});
          dispatch(this.setWatermarkFontFamilyAction(fontFamily));
        });
        dispatch(FJFontAction.updateLoadingFontAction(FJFontManager.loadingFonts()));
      }
    },

    /**
     * @description 设置图片水印url
     * @param url
     * @return {{type: string, url}}
     */
    setWatermarkUrlAction: function (url) {
		  return {
		    type: FJActionConstant.SET_WATERMARK_URL,
        url,
      }
    },

    /**
     * @description 设置图片水印状态
     * @param status
     * @return {{type: string, status}}
     */
    setWatermarkStatusAction: function (status) {
		  return {
		    type: FJActionConstant.SET_WATERMARK_STATUS,
        status,
      }
    },

    /**
     * @description 设置水印下载进度
     * @param progress
     * @return {{progress, type: string}}
     */
    setWatermarkProgressAction: function (progress) {
		  return {
		    type: FJActionConstant.SET_WATERMARK_PROGRESS,
        progress,
      };
    },

		/**
		 * @description 修改文字水印参数
		 * @param type
		 * @param data
		 * @returns {function(...[*]=)}
		 */
		setWatermarkParamsAction: function (type, data) {
			return (dispatch) => {
				if (data.type) {
					FJUtil.toggleScope(data.type);
				}

				let {SET_WATERMARK_DATA} = FJCanvasStore.command;

				switch (type) {
					case FJActionConstant.UP_WATERMARK_SIZE:
					  FJCanvasStore.executeSync(SET_WATERMARK_DATA, {size: data.value / 100}, {type: data.type})
						dispatch(this.setWatermarkSizeAction(data.value));
						break;
					case FJActionConstant.UP_WATERMARK_OPACITY:
            FJCanvasStore.executeSync(SET_WATERMARK_DATA, {opacity: data.value / 100}, {type: data.type})
						dispatch(this.setWatermarkOpacityAction(data.value));
						break;
					case FJActionConstant.UP_WATERMARK_POSITION:
            FJCanvasStore.executeSync(SET_WATERMARK_DATA, {position: data.value})
						dispatch(this.setWatermarkPositionAction(data.value));
						break;
					default:
						break;
				}
			}
		},

    retryWatermarkActon: function () {
		  return (dispatch) => {
		    FJCanvasStore.executeSync(FJCanvasStore.command.RETRY_WATERMARK);
		    dispatch(this.setWatermarkStatusAction(FJViewConstant.MEDIA_STATUS_DOWNLOADING));
		    dispatch(this.setWatermarkProgressAction(0));
      };
    },

    /**
     * @description 上传水印图片
     * @param file
     * @return {function(*): Promise<void>}
     */
		uploadWatermarkAction: function (file) {
      return async (dispatch) => {
        try {
          let minResource = await FJUtil.compressImage(file, 500, 500);
          let sourceId = await FJUtil.hashEncode(minResource)
          let cache = await FJMediaCacheStore.setMediaCache(sourceId, minResource);
          let url = cache.getUrl();
          FJCanvasStore.executeSync(FJCanvasStore.command.SET_WATERMARK_DATA, {
            mediaData: {
              sourceId,
              url,
              mediaStatus: FJViewConstant.MEDIA_STATUS_SUCCESS,
            }
          });
          dispatch(this.setWatermarkUrlAction(url));
          dispatch(this.setWatermarkStatusAction(FJViewConstant.MEDIA_STATUS_SUCCESS));
					dispatch(this.setWatermarkImageIsExistAction(true));
					dispatch(this.updateWatermarkAction());
        } catch (e) {
          console.log(e);
          dispatch(FJMediaAction.imageNotSupportAction());
        }
      }
    },

		/**
		 * @description 设置资源是否存在
		 * @param isExist
		 * @returns {{type: string, isExist: *}}
		 */
		setWatermarkImageIsExistAction: function(isExist) {
			return {
				type: FJActionConstant.SET_WATERMARK_IMAGE_IS_EXIST,
				isExist,
			}
		},

    /**
     * @description 移除水印
     * @return {function(*): Promise<void>}
     */
    removeWatermarkAction: function () {
      return async (dispatch) => {
        let url = '';
        let sourceId = '';
        let mediaStatus = FJViewConstant.MEDIA_STATUS_SUCCESS;
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_WATERMARK_DATA, {
          mediaData: {sourceId, url, mediaStatus}
        });
        dispatch(this.setWatermarkStatusAction(FJViewConstant.MEDIA_STATUS_SUCCESS));
        dispatch(this.setWatermarkUrlAction(url));
        dispatch(this.setWatermarkImageIsExistAction(false));
      }
    },

    updateWatermarkAction: function () {
      return (dispatch) => {
        const {WATERMARK_TEXT, WATERMARK_IMAGE} = FJCoreConstant;
        const watermark = FJCanvasStore.executeSync(FJCanvasStore.command.GET_WATERMARK);
        const curWatermark = watermark.getChild();
        if (curWatermark) {
          const {type} = curWatermark;
          dispatch(this.setWatermarkTypeAction(type));
          dispatch(this.setWatermarkSizeAction(curWatermark.getSize() * 100));
          dispatch(this.setWatermarkPositionAction(curWatermark.getPosition()));
          dispatch(this.setWatermarkOpacityAction(curWatermark.getOpacity() * 100));
          switch (curWatermark.type) {
            case WATERMARK_TEXT:
              dispatch(this.setWatermarkTextValueAction(curWatermark.getTextData().join('\n')));
              dispatch(this.setWatermarkFontFamilyAction(curWatermark.getFontFamily()));
              dispatch(this.setWatermarkFontColorAction(curWatermark.getColor()));
              break;
            case WATERMARK_IMAGE:
              dispatch(this.setWatermarkImageIsExistAction(!!curWatermark.sourceId));
              dispatch(this.setWatermarkUrlAction(curWatermark.getUrl()));
              if (curWatermark.getUrl()) {
                dispatch(this.setWatermarkStatusAction(FJViewConstant.MEDIA_STATUS_SUCCESS));
              }
              break;
          }
        } else {
          dispatch(this.setWatermarkTypeAction(WATERMARK_IMAGE));
          dispatch(this.setWatermarkImageIsExistAction(false));
        }
      };
    },

		/**
		 * @description 显示上传文件类型错误的模态框
		 */
		watermarkImageNotSupportAction: function () {
			return (dispatch) => {
				let data = {
					headerText: FJLocalStore._('logo-file-title'),
					bodyText: FJLocalStore._('watermark-file-content'),
					cancelType: 'cancel',
					hasCancel: false,
					submitText: FJLocalStore._('got-it')
				};
				dispatch(FJModalAction.showConfirmModalAction(data));
			}
		},

		/**
		 * @description 确认删除水印模态框
		 * @returns {function(...[*]=)}
		 */
		removeWatermarkImageAction: function () {
			return (dispatch) => {
				let data = {
					headerText: FJLocalStore._('remove-watermark-image'),
					bodyText: FJLocalStore._('remove-watermark-content'),
					onCancel: null,
					onSubmit: (callback) => {
						dispatch(this.removeWatermarkAction());
            callback();
					},
					submitDanger: true,
					cancelType: 'cancel',
					submitText: FJLocalStore._('remove')
				};
				dispatch(FJModalAction.showConfirmModalAction(data));
			}
		},
	}
})();

export default FJWatermarkAction;
